import React, { useEffect } from 'react'
import styles from  './overview3.module.css'
import {Link, useNavigate} from 'react-router-dom'
const TOOLS=["HTML","CSS","JAVASCRIPT","RESPONSIVE DESIGN"];

export default function Overview2() {
  const navigate=useNavigate();

  useEffect(()=>{
     window.scroll({top:0,behavior:"smooth"})
  },[])
  
  const navigateToProject=()=>{
    navigate('/project1')
  }

  const navigateToVideoPlatform=()=>{
    navigate('/project2')
  }

  return (
    <div className={styles.overview1}>
      <div className={styles.wrapper}>
        <div className={styles["title-container"]}>
          <div className={styles["game-title"]}>Memorygame</div>
        </div>
        <h3 className={styles.header}>Overview</h3>
        <p className={styles.overview}>
        The Memory Game is a game built with HTML, CSS, and JavaScript where player selects two cards at a time, aiming to find matching pairs by flipping them. The game continues 
        until all cards are successfully matched, requiring player to rely on memory and concentration.
        </p>
        <div className={styles.tools}>
          {TOOLS.map((t,index)=>(
            <span className={styles.tool} key={index}>{t}</span>
          ))}
        </div>
        <div className={styles.devices}>
            <div className={styles["macbook-container"]}>
              <img src="./images/memory-macbook.png" alt="" className={styles.macbook} />
              <img src="./images/memory-mobile.png" alt="" className={styles.phone}/>
              <img src="./images/memory-ipad.png" alt="" className={styles.ipad}/>
            </div>
        </div>
        <h3 className={styles.header}>Design</h3>
        <div className={styles.gallery}>
            <img src="./images/memory-game.webp" alt="" className={styles["vp-top"]} />
            <img src="./images/memory-finish.webp" alt="" className={styles["vp-contents"]} />
        </div>
        <div className={styles.icons}>
            <a href="https://www.linkedin.com/in/ryo-aoyama-21392222b/"><img src="./images/linkedin2.png" alt="" className={styles.linkedin}/></a>
            <a href='https://github.com/RyoGitacc/memory-game'><img src="./images/github-mark.png" alt="" className={styles.github}/></a>
        </div>
        <div className={styles['btn-container']}>
            <a href='https://memory-game-ryo-aoyama.netlify.app/'>
            <button className={styles.btn}>Visit Website</button>
            </a>
        </div>
        <h3 className={styles.header}>More Works</h3>
        <div className={styles["more-work"]}>
           <div className={styles.classified} onClick={navigateToProject}></div>
           <div className={styles.notyet} onClick={navigateToVideoPlatform}></div>
        </div>
        <p className={styles.back}>
          <Link to='/' className={styles.link}>
            Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
